import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=20d3facc&"
import script from "./UserFilters.vue?vue&type=script&lang=js&"
export * from "./UserFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports